export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/user-directories.controller.js